import React, { useState } from "react";
import {
  Box,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddReply from "../../Modals/addReply";

interface CustomerSupportListProps {
  status: 'pending' | 'resolved';
}

const CustomerSupportList: React.FC<CustomerSupportListProps> = ({ status }) => {
  const navigate = useNavigate();

  const [selectField1, setSelectField1] = useState("default");
  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectField1(event.target.value as string);
  };

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => setOpen(false);

  const rows = [
    {
      id: 1,
      title: "How do I sign up as a maintenance provider?",
      description:
        "Our Property Maintenance App is designed to simplify and streamline the process of managing property repairs and maintenance.",
      date: "01 March 2025",
    },
    {
      id: 2,
      title: "How do I sign up as a maintenance provider?",
      description:
        "Our Property Maintenance App is designed to simplify and streamline the process of managing property repairs and maintenance.",
      date: "01 March 2025",
    },
    {
      id: 3,
      title: "How do I sign up as a maintenance provider?",
      description:
        "Our Property Maintenance App is designed to simplify and streamline the process of managing property repairs and maintenance.",
      date: "01 March 2025",
    },
  ];

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Owner Detail</TableCell>
              <TableCell>Query Title</TableCell>
              <TableCell>Created Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow hover key={row.id}>
                <TableCell>
                  <a
                    href="/manage-users/detail"
                    className="user_block click_action"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/manage-users/detail");
                    }}
                  >
                    <figure>
                      <img
                        src="/static/images/user_placeholder.png"
                        alt="User profile"
                        width={40}
                      />
                    </figure>
                    <p>
                      <b>Madelyn Dias</b>
                      <span>madelyndias@gmail.com</span>
                    </p>
                  </a>
                </TableCell>

                <TableCell>
                  <Typography fontWeight={600}>{row.title}</Typography>
                </TableCell>
                <TableCell>{row.date}</TableCell>
                <TableCell>
                  {status === "pending" ? (
                    <div className="form">
                      <Select fullWidth value={selectField1} onChange={handleChange1}>
                        <MenuItem disabled value="default">
                          Select Status
                        </MenuItem>
                        <MenuItem value="pending">Pending</MenuItem>
                        <MenuItem value="resolved">Resolved</MenuItem>
                      </Select>
                    </div>
                  ) : (
                    <Box className="status_btn c_success">Resolved</Box>
                  )}
                </TableCell>
                <TableCell>
                  <div className="table_actions v2">
                    <Box>
                      <IconButton onClick={() => setOpen(true)}>
                        <img src="/static/images/reply_icon.svg" alt="Reply" />
                      </IconButton>
                    </Box>
                    <Box>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </Box>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <AddReply open={open} onClose={handleCloseModal} setOpen={setOpen} status={status} />
    </>
  );
};

export default CustomerSupportList;
